import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'data-table-error',
  templateUrl: './data-table-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DataTableErrorComponent {
  @Input() public errorText;
  @Input() public actionableText;
  @Input() public deepLinkMessage;
  @Input() public isVisibleDeepLinkMsg;

  @Output() public textClick = new EventEmitter<any>();
  @Output() public deepLinkMessageClick = new EventEmitter<any>();

  public textClicked() {
    this.textClick.emit();
  }

  public onClickDeepLinkMsg() {
    this.deepLinkMessageClick.emit();
  }
}
